import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import MobileFormInput from 'components/MobileFormInput';
import { useFormik } from 'formik';
import * as yup from 'yup';
import styles from './index.module.scss';
import clsx from 'clsx';
import authService from 'store/auth/service';
import { IUser } from 'store/user/interfaces';
import { useLocation, useNavigate } from 'react-router-dom';
import { DriverDocumentsPage } from 'routes/paths';
import { Snackbar } from '@mui/material';
import { localStorageWrapper } from 'functions/localStorage';

export interface PersonalDataFormProps {
  className?: string;
  organizationAlias: string;
  phoneNumber: string;
}

export const validationSchema = yup.object({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  alphaCode: yup.string().required('Alpha code is required'),
});

export function PersonalDataForm(props: PersonalDataFormProps) {
  const [login, { isLoading }] =
    authService.endpoints.unsecuredLoginCandidate.useMutation();
  const [checkUserCandidate] = authService.useLazyCheckUserCandidateQuery();
  const navigate = useNavigate();
  const { state } = useLocation();

  const formik = useFormik({
    validationSchema,
    initialValues: {},
    validateOnChange: false,
    onSubmit: async (values: any) => {
      const loginResult = await login({
        phone: props.phoneNumber,
        firstName: values.firstName,
        lastName: values.lastName,
        employeeId: values.alphaCode,
        organizationAlias: props.organizationAlias,
      });

      const checkUserCandidateResponse = await checkUserCandidate();
      if ((checkUserCandidateResponse as any).error)
        return <Snackbar message={'Invalid Credentials'} />;

      const user = (loginResult as any).data as IUser;

      window.analytics.identify(user._id, {
        created: new Date(),
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        roles: user.roles,
        hostname: window.location.hostname,
      });
      localStorageWrapper.setSessionType('not-verified');
      return navigate(state?.path || DriverDocumentsPage);
    },
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      className={clsx(styles.form, props.className)}
    >
      <MobileFormInput
        name="firstName"
        formik={formik}
        inputProps={{
          placeholder: 'First Name',
        }}
      />
      <MobileFormInput
        name="lastName"
        formik={formik}
        inputProps={{
          placeholder: 'Last Name',
        }}
      />
      <MobileFormInput
        name="alphaCode"
        formik={formik}
        inputProps={{
          placeholder: 'Alpha Code',
        }}
      />
      <ButtonWithArrowIcon
        type="submit"
        className={styles.confirmButton}
        disabled={isLoading}
      >
        Continue
      </ButtonWithArrowIcon>
    </form>
  );
}

export default PersonalDataForm;
